import React from 'react'
import {Link} from 'react-router-dom'
import './style.css'
import scheduleIcon from '../../images/SVG/schedule.svg'
import groupIcon from '../../images/SVG/group.svg'
import demoIcon from '../../images/SVG/demo.svg'
import teacherIcon from '../../images/SVG/teacher.svg'
import priceIcon from '../../images/SVG/price.svg'
import culturalIcon from '../../images/SVG/cultural.svg'

const SupportAbout = (props) => {

    const whyChooseUs = [
        {
            icon: scheduleIcon,
            title: "Flexible Scheduling",
            description: "We offer classes throughout the week, including evenings and weekends, to match your family's timetable."
        },
        {
            icon: groupIcon,
            title: "One-to-One or Small Group Classes",
            description: "Learn in a format that suits you – personalised one-to-one tuition or small groups (2–4 students) for peer learning."
        },
        {
            icon: demoIcon,
            title: "Free Demo Class",
            description: "Try any course with no obligation. Experience our teaching style before committing."
        },
        {
            icon: teacherIcon,
            title: "Qualified Teachers",
            description: "Our tutors hold Quran/Quranic education certificates and have years of teaching experience."
        },
        {
            icon: priceIcon,
            title: "Affordable & Transparent Pricing",
            description: "Competitive fees with no hidden costs. Discounts available for siblings and term packages."
        },
        {
            icon: culturalIcon,
            title: "Culturally Relevant",
            description: "Lessons are designed for UK learners, respecting local culture while staying true to Islamic tradition."
        }
    ];

    const faqs = [
        {
            question: "Who can join these classes?",
            answer: "We welcome children   and adults of all levels, from complete beginners to advanced students. Everyone can start at their own pace."
        },
        {
            question: "How are classes delivered?",
            answer: "All classes are live online (using Zoom or similar). You can choose one-to-one or small-group sessions. We schedule classes to suit UK time zones and school/work schedules."
        },
        {
            question: "Can I try a class for free?",
            answer: "Yes! We offer a free demo lesson so you can see how we teach before enrolling. Just contact us to book your free trial."
        },
        {
            question: "What qualifications do the teachers have?",
            answer: "Our tutors are certified in Tajweed and Quranic teaching, with extensive experience in online education. We have both male and female teachers to suit your preference."
        }
    ];

    return(
        <div className="support-about-area">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="section-title text-center">
                            <span>Our Advantages</span>
                            <h2>Why Choose Us</h2>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {whyChooseUs.map((item, index) => (
                        <div className="col-lg-4 col-md-6 col-sm-12" key={index}>
                            <div className="why-choose-item">
                                <div className="why-choose-icon">
                                    <img src={item.icon} alt={item.title} />
                                </div>
                                <h3>{item.title}</h3>
                                <p>{item.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="row mt-5">
                    <div className="col-lg-12">
                        <div className="get-started-box text-center">
                            <h3>Ready to begin your Quran journey?</h3>
                            <p>Book a free demo class today or contact us for more information about enrollment and schedules.</p>
                            <div style={{ position: 'relative', zIndex: 9999 }}>
                                <a href="/home#booking-form" className="theme-btn-s3">Book Free Trial</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mt-5">
                    <div className="col-lg-12">
                        <div className="section-title text-center">
                            <span>Common Questions</span>
                            <h2>Frequently Asked Questions</h2>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="faq-wrapper">
                            {faqs.map((faq, index) => (
                                <div className="faq-item" key={index}>
                                    <div className="faq-question">
                                        <h3><i className="ti-help-alt"></i> Q: {faq.question}</h3>
                                    </div>
                                    <div className="faq-answer">
                                        <p><i className="ti-comment-alt"></i> A: {faq.answer}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SupportAbout; 